import { FilteredBackground } from "@/components/vault/viewer/backgrounds/FilteredBackground";
import { ThumbnailCaptureBackground } from "@/components/vault/viewer/backgrounds/ThumbnailCaptureBackground";
import { UploaderBackground } from "@/components/vault/viewer/backgrounds/UploaderBackground";
import { useScreenStore } from "@/stores/useScreenStore";
import useVaultStore from "@/stores/zustand/vault/useVaultStore";

interface VaultObjectViewerBackgroundProps {
  uploadLoading: boolean;
  uploadComplete: boolean;
  uploadFailed: boolean;
}

export const VaultObjectViewerBackground = ({
  uploadLoading,
  uploadComplete,
  uploadFailed,
}: VaultObjectViewerBackgroundProps) => {
  const isMobileScreen = useScreenStore((state) => state.isMobileScreen);

  const currentPage = useVaultStore((state) => state.currentPage);
  const vaultObjectViewerDate = useVaultStore(
    (state) => state.vaultObjectViewerData,
  );
  return (
    <div
      className={
        "pointer-events-none absolute inset-0 bg-[var(--white)] overflow-hidden z-0"
      }
      style={{
        borderRadius:
          (vaultObjectViewerDate?.embed || isMobileScreen) &&
          !currentPage.endsWith("thumbnail")
            ? 0
            : "20px",
      }}
    >
      {(currentPage === "viewer" || currentPage === "uploader") && (
        <FilteredBackground />
      )}
      {currentPage.endsWith("thumbnail") &&
        (uploadLoading || uploadComplete || uploadFailed ? (
          <UploaderBackground
            uploadLoading={uploadLoading}
            uploadComplete={uploadComplete}
            uploadFailed={uploadFailed}
          />
        ) : (
          <ThumbnailCaptureBackground />
        ))}
    </div>
  );
};
